import { Layout } from '@/components/forms/fields/types';
import {
  makeOptional,
  makeLayoutOptionalExcept,
  // changeMeta,
} from '@/components/forms/field.schema';
import { ticketFields } from './ticket.fields';

// 1. Destructure fields for readability and type safety.
const {
  title,
  status,
  description,
  due,
  assignee_user_id,
  executor_user_id,
  labels,
  creator_user_id,
  created,
  modified,
  notification_opt_in,
  project_id,
  // werk_id,
  hidden_werk_id,
  hidden_client_id,
} = ticketFields;

// 2. Define the layout object. The keys are the group names.
export const ticketDetailLayout = {
  '': {
    title,
    description,
    labels,
    project_id, // The cascading component will manage both project_id and werk_id
    werk_id: hidden_werk_id, // FIXME: -> changeMeta(werk_id, { fieldType: 'hidden' }), // Hidden field, managed by the cascading component
    client_id: hidden_client_id, // Hidden, managed by the cascading component
  },
  Planning: {
    assignee_user_id,
    executor_user_id,
    due,
    notification_opt_in,
  },
} satisfies Layout;

export const createTicketDetailLayout = makeLayoutOptionalExcept(
  ticketDetailLayout,
  ['title'],
);

export const ticketBulkEditLayout = {
  '': {
    status: makeOptional(status),
    due: makeOptional(due),
    assignee_user_id: makeOptional(assignee_user_id),
    executor_user_id: makeOptional(executor_user_id),
    add_labels: makeOptional(labels, { label: 'Add labels' }),
    remove_labels: makeOptional(labels, { label: 'Remove labels' }),
    project_id: makeOptional(project_id, {
      fullWidth: true,
      visibleIn: ['edit'],
    }),
    werk_id: makeOptional(hidden_werk_id), // FIXME: ->  makeOptional(changeMeta(werk_id, { fieldType: 'hidden' })),
    client_id: makeOptional(hidden_client_id),
  },
};
